/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationByOptimizationTypes {
    getFixupPrototypeFunction() { return CostOptimizationByOptimizationTypes.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationByOptimizationTypes>): CostOptimizationByOptimizationTypes {
        let obj = Object.assign(new CostOptimizationByOptimizationTypes(), model);
        CostOptimizationByOptimizationTypes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationByOptimizationTypes>): CostOptimizationByOptimizationTypes {
        if (!model) return null;
        return CostOptimizationByOptimizationTypes.newInstance(<CostOptimizationByOptimizationTypes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationByOptimizationTypes) {
        if (!obj) return;

        models.CostOptimizationByOptimizationTypes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationByOptimizationTypes): boolean {
        Object.setPrototypeOf(obj, CostOptimizationByOptimizationTypes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_savings === undefined) {
            this.cost_savings = 0;
        }
        if (this.cost_forecast === undefined) {
            this.cost_forecast = 0;
        }
    }

    /**
     * savings of the optimization types
     */
    cost_savings: number;

    /**
     * forecast spend of the optimization type
     */
    cost_forecast: number;

    /**
     * optimization type
     */
    optimization_type: string;

    /**
     * cloud account id
     */
    cloud_account: string;

    /**
     * Cloud Provider for the cloud account
     */
    cloud_provider: models.CloudServiceName;

    /**
     * region
     */
    region: string;

    /**
     * resource name
     */
    resource_name: string;

    /**
     * resource type
     */
    resource_type: string;

    /**
     * resource_id
     */
    resource_id: string;

    /**
     * resource category
     */
    resource_category: string;

    /**
     * optimization name
     */
    optimization_name: string;

}
